import Lesson from "./lesson";

export default Lesson;